import React, { createContext, useEffect, useState } from "react";
import appConfig from "../config/appConfig";

export interface ThemeContextProps {
	theme: string;
	toggleTheme: () => void;
}

export const ThemeContext = createContext<ThemeContextProps | undefined>(
	undefined,
);

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({
	children,
}) => {
	const getInitialTheme = () => {
		const storedTheme = localStorage.getItem("theme")?.trim().toLowerCase();
		if (storedTheme === "light" || storedTheme === "dark") {
			return storedTheme;
		}
		// Default to light if not set or invalid
		localStorage.setItem("theme", "light");
		return "dark";
	};
	const [theme, setTheme] = useState<string>(getInitialTheme);

	const toggleTheme = () => {
		const newTheme = theme === "light" ? "dark" : "light";
		setTheme(newTheme);
		localStorage.setItem("theme", newTheme);
	};

	useEffect(() => {
		document.documentElement.classList.remove("light", "dark");

		if (["light", "dark"].includes(theme)) {
			document.documentElement.classList.add(theme);

			const favicon = document.querySelector<HTMLLinkElement>("#app-favicon");
			if (favicon) {
				favicon.href = `${process.env.PUBLIC_URL}/logo-${theme}.ico`;
			}
		} else {
			console.error("Invalid theme value:", theme);
		}
	}, [theme]);

	return (
		<ThemeContext.Provider value={{ theme, toggleTheme }}>
			{children}
		</ThemeContext.Provider>
	);
};
